// extracted by mini-css-extract-plugin
export default {"root":"topten_root__viaap","carousel":"topten_carousel__gO8Ze","title":"topten_title__ncjC6"};